import { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

interface Props {
  border?: boolean;
  children: ReactNode;
  header: ReactNode;
  icon?: Icon;
}

const CardHeader = ({ border = false, children, header, icon }: Props) => {
  const className = classnames({
    flex: true,
    'flex-row': true,
    'justify-center': true,
    'text-card-subtitle-color': true,
    'p-2': true,
    'border-b': border,
    'border-b-card-inset-background-color': border,
  });

  return (
    <div className={className}>
      <div className="flex flex-row">
        <div className="flex items-center pr-2">
          <IconView icon={icon} size={'lg'} />
        </div>
        <div>{header}</div>
      </div>
      <div className="flex grow justify-end items-center">{children}</div>
    </div>
  );
};

export default CardHeader;
